import { makeAutoObservable } from "mobx";
import { SearchObject } from "app/common/Model/SearchObject";
import { checkSearchObject } from "app/common/LocalFunction";
import { toast } from "react-toastify";
import {
  pagingNutritionOrder,
  getNutritionOrderById,
  deleteNutritionOrder,
  saveNutritionOrder,
} from "app/services/NutritionOrderService";
import { NutritionOrder } from "app/common/Model/NutritionOrder";

export default class NutritionOrderStore {
  listAllNutritionOrder = [];
  searchNutritionOrder = new SearchObject();
  pageNutritionOrder = null;
  selectedNutritionOrder = null;
  openFormCreateOrEdit = false;
  openConfirmDeleteNutritionOrder = false;

  constructor() {
    makeAutoObservable(this);
  }

  pagingNutritionOrder = async () => {
    try {
      const res = await pagingNutritionOrder(this.searchNutritionOrder);
      this.pageNutritionOrder = res.data;
    } catch (error) {
      console.error(error);
      toast.error("Lấy dữ liệu có lỗi");
    }
  };

  handleChangeFormSearch = (searchNutritionOrder) => {
    this.searchNutritionOrder = checkSearchObject(
      this.searchNutritionOrder,
      searchNutritionOrder
    );
    this.pagingNutritionOrder();
  };

  handleOpenFormCreateOrEdit = async (nutritionOrder) => {
    try {
      if (Boolean(nutritionOrder)) {
        const res = await getNutritionOrderById(nutritionOrder);
        this.selectedNutritionOrder = res.data;
        this.openFormCreateOrEdit = true;
      } else {
        this.selectedNutritionOrder = new NutritionOrder();
        this.openFormCreateOrEdit = true;
      }
    } catch (error) {
      console.error(error);
      toast.error("Lấy dữ liệu có lỗi");
    }
  };

  saveNutritionOrder = async (nutraceuticals, { setSubmitting }) => {
    try {
      await saveNutritionOrder(nutraceuticals);
      this.selectedNutritionOrder = null;
      toast.success("Lưu thông tin chế độ ăn thành công!");
      this.handleClosePopup();
      this.pagingNutritionOrder();
      setSubmitting(false);
    } catch (error) {
      console.error(error);
      toast.error("Lưu thông tin chế độ ăn có lỗi");
    }
  };

  handleDeleteNutritionOrder = (nutraceuticals) => {
    this.selectedNutritionOrder = { id: nutraceuticals.id };
    this.openConfirmDeleteNutritionOrder = true;
  };

  handleConfirmDeleteNutritionOrder = async () => {
    try {
      await deleteNutritionOrder(this.selectedNutritionOrder?.id);
      if (
        this.searchNutritionOrder?.pageIndex > 1 &&
        this.searchNutritionOrder?.content?.length === 1
      ) {
        this.searchNutritionOrder.pageIndex -= 1;
      }
      toast.success("Xóa chế độ ăn thành công!");
      this.handleClosePopup();
      this.pagingNutritionOrder();
    } catch (error) {
      console.error(error);
      toast.error("Đã có lỗi xảy ra vui lòng thử lại!");
    }
  };

  handleClosePopup = () => {
    this.openFormCreateOrEdit = false;
    this.openConfirmDeleteNutritionOrder = false;
  };

  resetStore = () => {
    this.searchNutritionOrder = new SearchObject();
    this.pageNutritionOrder = null;
    this.selectedNutritionOrder = null;
    this.openFormCreateOrEdit = false;
    this.openConfirmDeleteNutritionOrder = false;
  };
}
